export const FEED_QUERY_RETENTION_KEY = 'feedQueryRetentionKey';
